const React = require('react');
const { createElement: h, useState, useEffect, useRef } = React;
const { request } = require('../lib/apiClient');
const SparkleIcon = require('./SparkleIcon');
require('./ClassifierConfiguratorModal.css');

function ClassifierConfiguratorModal(props) {
  var onConfirm = props.onConfirm;
  var onCancel = props.onCancel;

  var [prompt, setPrompt] = useState('');
  var [loading, setLoading] = useState(false);
  var [error, setError] = useState('');
  var [result, setResult] = useState(null);
  var [newLabel, setNewLabel] = useState('');
  var textareaRef = useRef(null);
  var newLabelRef = useRef(null);

  useEffect(function() {
    if (textareaRef.current) textareaRef.current.focus();
  }, []);

  function handleKeyDown(e) {
    if (e.key === 'Escape') onCancel();
    if (e.key === 'Enter' && (e.metaKey || e.ctrlKey) && prompt.trim() && !loading) configure();
  }

  function configure() {
    var p = prompt.trim();
    if (!p) {
      if (textareaRef.current) textareaRef.current.focus();
      return;
    }
    setLoading(true);
    setError('');
    setResult(null);
    request('/ai/configure-classifier', {
      method: 'POST',
      body: { prompt: p, variables: [] }
    })
      .then(function(data) {
        setResult({
          labels: Array.isArray(data.labels) ? data.labels : ['positive', 'negative', 'neutral'],
          instruction: data.instruction || ''
        });
        setLoading(false);
      })
      .catch(function(err) {
        setError(err.message || 'Failed to configure. Please try again.');
        setLoading(false);
      });
  }

  function addLabel() {
    var trimmed = newLabel.trim();
    if (!trimmed || !result) return;
    if (result.labels.indexOf(trimmed) >= 0) return;
    setResult(Object.assign({}, result, { labels: result.labels.concat(trimmed) }));
    setNewLabel('');
    setTimeout(function() { if (newLabelRef.current) newLabelRef.current.focus(); }, 0);
  }

  function removeLabel(label) {
    if (!result) return;
    setResult(Object.assign({}, result, { labels: result.labels.filter(function(l) { return l !== label; }) }));
  }

  function handleLabelKeyDown(e) {
    if (e.key === 'Enter') { e.preventDefault(); addLabel(); }
  }

  function handleConfirm() {
    if (result && result.labels.length > 0) {
      onConfirm({ labels: result.labels.join(','), instruction: result.instruction || '' });
    } else if (prompt.trim()) {
      onConfirm({ labels: 'positive,negative,neutral', instruction: prompt.trim() });
    }
  }

  return h('div', { className: 'ccm-overlay', onMouseDown: function(e) { if (e.target === e.currentTarget) onCancel(); } },
    h('div', { className: 'ccm-modal', onKeyDown: handleKeyDown, onMouseDown: function(e) { e.stopPropagation(); } },

      h('div', { className: 'ccm-header' },
        h('div', { className: 'ccm-header-icon' },
          h(SparkleIcon, { className: 'ccm-header-icon-svg', size: 15 })
        ),
        h('div', { style: { flex: 1, minWidth: 0 } },
          h('div', { className: 'ccm-title' }, 'Configure Classifier'),
          h('div', { className: 'ccm-subtitle' }, 'Describe what to classify \u2014 AI will generate the labels')
        ),
        h('button', { className: 'ccm-close', onClick: onCancel }, '\u00d7')
      ),

      h('div', { className: 'ccm-body' },
        h('div', { className: 'ccm-field' },
          h('label', { className: 'ccm-label' }, 'What should be classified?'),
          h('textarea', {
            ref: textareaRef,
            className: 'ccm-textarea',
            rows: 3,
            placeholder: 'e.g. "Classify customer sentiment" or "Categorize support tickets into billing, technical, account, other"',
            value: prompt,
            onChange: function(e) { setPrompt(e.target.value); setResult(null); setError(''); },
            onKeyDown: handleKeyDown,
            disabled: loading
          })
        ),

        h('button', {
          className: 'ccm-configure-btn',
          onClick: configure,
          disabled: loading
        },
          loading
            ? h('span', { className: 'ccm-spinner' })
            : h('span', { className: 'ccm-btn-icon', 'aria-hidden': 'true' },
                h(SparkleIcon, { className: 'ccm-btn-icon-svg', size: 15 })
              ),
          loading ? 'Configuring...' : 'Configure with AI'
        ),

        error ? h('div', { className: 'ccm-error' }, error) : null,

        result
          ? h('div', { className: 'ccm-result' },
              h('div', { className: 'ccm-result-header' },
                h('span', { className: 'ccm-result-label' }, 'Generated Configuration'),
                h('span', { className: 'ccm-result-badge' }, 'AI')
              ),

              h('div', { className: 'ccm-result-field' },
                h('span', { className: 'ccm-result-key' }, 'Classification Labels'),
                h('div', { className: 'ccm-result-tags' },
                  result.labels.map(function(label) {
                    return h('span', { key: label, className: 'ccm-result-tag' },
                      label,
                      h('button', {
                        className: 'ccm-result-tag-remove',
                        onClick: function() { removeLabel(label); }
                      }, '\u00d7')
                    );
                  }),
                  h('div', { className: 'ccm-result-add-row' },
                    h('input', {
                      ref: newLabelRef,
                      className: 'ccm-result-add-input',
                      type: 'text',
                      placeholder: '+ Add label',
                      value: newLabel,
                      onChange: function(e) { setNewLabel(e.target.value); },
                      onKeyDown: handleLabelKeyDown
                    })
                  )
                )
              ),

              h('div', { className: 'ccm-result-field' },
                h('span', { className: 'ccm-result-key' }, 'Instruction'),
                h('textarea', {
                  className: 'ccm-result-textarea',
                  rows: 3,
                  value: result.instruction,
                  onChange: function(e) { setResult(Object.assign({}, result, { instruction: e.target.value })); }
                })
              )
            )
          : null
      ),

      h('div', { className: 'ccm-actions' },
        h('button', { className: 'ccm-btn ccm-btn-secondary', onClick: onCancel }, 'Cancel'),
        h('button', {
          className: 'ccm-btn ccm-btn-primary',
          onClick: handleConfirm,
          disabled: !result && !prompt.trim()
        }, 'Add Node')
      )
    )
  );
}

module.exports = ClassifierConfiguratorModal;
